import type { SupraLockboxActivities } from '@bb/domain/dist/types';
import type { CancelToken } from 'axios';
import axios from 'axios';

export type LockboxesActivityFilterOptions = {
  ownerOrAssignee?: string[];
  ownerIds?: string[];
  lockboxIds?: string[];
  activities?: SupraLockboxActivities[] | [];
  lockboxSerialNumbers?: string[] | [];
  startDate?: Date | null;
  endDate?: Date | null;
  userIds?: string[];
  assignee?: string[];
  listingIds?: string[];
  keyTypes?: string[];
  search?: string;
};

export const getListingAccessActivitiesLink = ({
  listingId,
  page = 1,
  filters,
  exportCsv,
}: {
  listingId: string;
  filters?: LockboxesActivityFilterOptions;
  sort?: {
    sort: string;
    order: 'ascend' | 'descend';
  };
  page?: number;
  exportCsv?: boolean;
}): string => axios.getUri({
    url: `/listing/${listingId}/access_activity`,
    params: {
      ...filters,
      page: page - 1,
      ...(exportCsv ? { exportCsv } : {}),
    },
  });

const getListingAccessActivities = async ({
  listingId,
  page = 1,
  filters,
  cancelToken,
}: {
  listingId: string;
  page: number;
  filters: any;
  cancelToken: CancelToken;
}) => {
  const result = await axios.get<{ activities: any[]; count: number }>(
    `/listing/${listingId}/access_activity`,
    {
      cancelToken,
      params: {
        page: page - 1,
        ...filters,
      },
    },
  );
  return result.data;
};

export default getListingAccessActivities;
